import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { PurchaseInvoiceFileImportContainerModel } from '../../../../../../models/aggregates/erp/purchase-invoice-file-import/index';

@Injectable({
  providedIn: 'root'
})
export class PurchaseInvoiceFileImportService extends BaseApiTemplateService<PurchaseInvoiceFileImportContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-invoice/import-file-hdr/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-invoice/import-file-hdr/backoffice-ep';
    this.httpClient = http;
  }

  async sampleCommaCSV(authorization: string, apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template-comma';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }

  async samplePipeCSV(authorization: string, apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template-pipe';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }
}